"use client";

import { LoginSessionRepair } from "@/components/login-session-repair";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useRouter, useSearchParams } from "next/navigation";

export default function LoginClient() {
  const searchParams = useSearchParams();
  const router = useRouter();

  const callbackUrl = searchParams.get("callbackUrl") || "/";
  const error = searchParams.get("error"); // например invalid_credentials

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Войти</CardTitle>
        </CardHeader>

        <CardContent>
          {error && (
            <Alert variant="destructive" className="mb-4">
              <AlertDescription>
                {error === "invalid_credentials"
                  ? "Неверный логин или пароль"
                  : "Ошибка авторизации"}
              </AlertDescription>
            </Alert>
          )}

          <form action="/auth/login" method="POST" className="space-y-4">
            <input type="hidden" name="callbackUrl" value={callbackUrl} />

            <div className="space-y-2">
              <Label htmlFor="username">Логин</Label>
              <Input
                id="username"
                name="username"
                type="text"
                autoComplete="username"
                placeholder="Введите логин..."
                required
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password">Пароль</Label>
              <Input id="password" name="password" type="password" required />
            </div>

            <Button type="submit" className="w-full">
              Войти
            </Button>
          </form>
        </CardContent>

        <CardFooter className="justify-center">
          <span className="text-muted-foreground">Нет аккаунта?</span>
          <Button
            variant="link"
            size="xs"
            onClick={() => router.push("/signup")}
          >
            Зарегистрироваться
          </Button>
        </CardFooter>

        <LoginSessionRepair callbackUrl={callbackUrl} />
      </Card>
    </div>
  );
}
